module.exports = __webpack_public_path__ + "img/adequation-logo-square.52c6b776.svg";